import { default as _InteractiveRenderer } from './components/InteractiveRenderer';

export const InteractiveRenderer = _InteractiveRenderer;